var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseContract(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.23,
    height: 14.23,
    viewBox: "0 0 14.23 14.23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#074f8c;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M19.23,6.433,17.8,5l-5.682,5.682L6.433,5,5,6.433l5.682,5.682L5,17.8,6.433,19.23l5.682-5.682L17.8,19.23,19.23,17.8l-5.682-5.682Z",
    transform: "translate(-5 -5)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseContract);
export default __webpack_public_path__ + "static/media/close_contract.054a5ff9e45b7280c38ae00f6f5f8a17.svg";
export { ForwardRef as ReactComponent };